export default __webpack_public_path__ + "static/media/3-grid.14903110.webp";